import TopBar from '../components/TopBar';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const NotFound = () => {
  return (
    <div style={{ background: 'var(--page-bg)', minHeight: '100vh' }}>
      <TopBar />
      <div className="max-w-7xl mx-auto pt-24 pb-16 px-4 text-center">
        <h1 className="text-4xl font-bold mb-6" style={{ color: 'var(--input-color)' }}>
          404 - Page Not Found
        </h1>
        <p className="text-xl mb-8" style={{ color: 'var(--text-secondary)' }}>
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="px-6 py-3 inline-block rounded-lg font-medium transition-all"
          style={{
            background: 'var(--button-bg)',
            color: 'var(--button-text)'
          }}
        >
          Return Home
        </Link>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;